import { useMemo } from 'react'

import { useGetUserQuery } from 'shared/api/auth/requests'
import { useUserContext } from 'shared/hooks/useUserContext'

export const useUserCompanies = () => {
  const { user } = useUserContext()

  const { data: userData } = useGetUserQuery(
    { id: user?.id || -1 },
    { enabled: typeof user?.id === 'number' }
  )

  const companies = useMemo(() => userData?.data.partners || [], [userData])

  const selectedCompany = companies.find(
    company => company.id === user?.organization_id
  )

  return { companies, selectedCompany }
}
